export const POPUP_TEXT_1 =
  'IPO Registrars are independent financial institutions registered with stock exchanges and appointed by the company going public for mainly to keep record of the issue and ownership of company shares.';
export const POPUP_TEXT_2 =
  'In case of any issue faced during the IPO process, you can reach out to the registrar.';
